import { useContext } from "react";
import { useAppSelector } from "../../store";
import { DEMO_BOARD_SLUG } from "../../../../constants/boards";
import {
  BoardIdContext,
  BoardShipmentIds,
} from "./state-machine/reviewBoardFlowLoader";
import useSWRFetcher from "../fetcher";
import useSWR from "swr";
import settings from "../../../../constants/settings";
import { Board } from "../../../../reducers/uploadedBoard";

export function useBoardFromContext() {
  const { boardId } = useContext(BoardIdContext) as BoardShipmentIds;
  const board = useAppSelector(
    (state) => state.uploadedBoard.boards[boardId]?.board || null,
  );
  const isDemoBoard = board?.id == DEMO_BOARD_SLUG;

  return {
    board,
    isDemoBoard,
  };
}

export function useBoard(boardId: string | null) {
  const fetcher = useSWRFetcher<Board>(undefined);

  const { data } = useSWR<Board>(
    boardId === null ? null : `${settings.api_url}/boards/${boardId}`,
    fetcher,
  );

  return { board: data || null };
}
